module.exports = __webpack_public_path__ + "img/4.a892dcf8.jpg";